module.exports = __webpack_public_path__ + "img/la-solid-900.79be4e9f.svg";